import React from 'react';
import { Button } from 'antd';
import { withRouter } from 'react-router-dom';

export const InternalLink = ({ value: { title, url, id }, history: { push } }) => (
  <div>
    <Button
      href={`/pages/${id}`}
      onClick={e => {
        e.preventDefault();
        push(`/pages/${id}`);
      }}
      data-internal={url}
    >
      {title}
    </Button>
  </div>
);

export default withRouter(InternalLink);



// WEBPACK FOOTER //
// ./src/modules/CMS/components/InternalLink/index.js